<template>
  <div class="container-fluid mt-0 p-0">
    <!-- Header with Gradient -->
    <div class="header-gradient mb-4 px-4 py-5">
      <div style="max-width: 600px; margin: 0 auto;">
        <h3 class="fw-bold text-white mb-1">🔍 추첨 결과 조회</h3>
        <p class="text-white-50 mb-0 small">차량번호를 입력하여 당첨 여부를 확인하세요</p>
      </div>
    </div>

    <div style="max-width: 600px; margin: 0 auto; padding: 0 1rem;">
      <!-- 검색 폼 -->
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-body p-4">
          <div class="mb-3">
            <label class="form-label fw-bold mb-2">차량번호</label>
            <div class="input-group input-group-lg">
              <input
                v-model="carNumber"
                type="text"
                class="form-control"
                placeholder="예: 21가2222"
                maxlength="20"
                @keyup.enter="searchTicketResult"
                :disabled="loading"
              />
              <button
                class="btn btn-primary"
                type="button"
                @click="searchTicketResult"
                :disabled="!carNumber.trim() || loading"
              >
                {{ loading ? '조회 중...' : '확인' }}
              </button>
            </div>
            <small class="text-muted d-block mt-2">
              💡 전체 차량번호를 입력해주세요 (예: 21가2222)
            </small>
          </div>
        </div>
      </div>

      <!-- 로딩 상태 -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">조회 중...</span>
        </div>
        <p class="mt-3 text-muted">조회 중입니다...</p>
      </div>

      <!-- 오류 -->
      <div v-else-if="error" class="alert alert-danger" role="alert">
        <h5 class="alert-heading">오류 발생</h5>
        <p class="mb-0">{{ error }}</p>
      </div>

      <!-- 당첨 결과 -->
      <div v-else-if="hasSearched">
        <!-- 당첨 -->
        <div v-if="result.found" class="card shadow-sm border-0 border-success">
          <div class="card-body p-4 text-center">
            <div class="mb-3" style="font-size: 3rem;">
              🎉
            </div>
            <h4 class="fw-bold text-success mb-3">
              축하합니다 정기권에 당첨되었습니다
            </h4>
            <div class="alert alert-light border border-success mb-3">
              <table class="table table-sm mb-0">
                <tbody>
                  <tr>
                    <th class="text-start ps-0" style="width: 100px;">주차장</th>
                    <td class="ps-3">{{ result.winner.areaName }}</td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          
          </div>
        </div>

        <!-- 미당첨 -->
        <div v-else class="card shadow-sm border-0 border-warning">
          <div class="card-body p-4 text-center">
            <div class="mb-3" style="font-size: 3rem;">
              😔
            </div>
            <h4 class="fw-bold text-warning mb-3">
              죄송합니다 당첨되지 않으셨습니다
            </h4>
            <p class="text-muted mb-0">
              다음기회에 다시 이용해주세요
            </p>
          </div>
        </div>

        
      </div>

      <!-- 안내 메시지 (검색 전) -->
      <div v-else class="text-center py-5 text-muted">
        <p class="mb-2">차량번호를 입력하고 확인 버튼을 클릭하세요.</p>
        <p class="small">당첨 여부를 바로 알려드립니다.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TicketResultPersonal',
  data() {
    return {
      carNumber: '',
      loading: false,
      error: null,
      hasSearched: false,
      result: {
        found: false,
        winner: null
      }
    }
  },
  mounted() {
    // 로그인 확인
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      const user = sessionStorage.getItem('user');
      if (!user) {
        // 로그인되지 않음 - 로그인 페이지로 리다이렉트
        this.$router.push('/login');
      }
    },
    async searchTicketResult() {
      const trimmedCarNumber = this.carNumber.trim();
      
      if (!trimmedCarNumber) {
        this.error = '차량번호를 입력해주세요.';
        return;
      }
      
      this.loading = true;
      this.error = null;
      this.hasSearched = false;
      
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/ticket-result-personal`, {
          params: {
            carNumber: trimmedCarNumber
          }
        });
        
        if (res.data.success) {
          this.result = {
            found: res.data.found,
            winner: res.data.winner || null
          };
          this.hasSearched = true;
        } else {
          this.error = res.data.message || '조회 중 오류가 발생했습니다.';
        }
      } catch (e) {
        console.error('searchTicketResult error:', e);
        this.error = e.response?.data?.message || '서버 오류가 발생했습니다.';
      } finally {
        this.loading = false;
      }
    },
    
  }
}
</script>

<style scoped>
.header-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 0;
}

.card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
}

.card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.card-body {
  padding: 2rem;
}

.input-group-lg .form-control,
.input-group-lg .btn {
  height: 48px;
  font-size: 1rem;
}

.table {
  margin-bottom: 0;
}

.table tbody tr {
  border-bottom: 1px solid #e9ecef;
}

.table tbody tr:last-child {
  border-bottom: none;
}

.table th,
.table td {
  padding: 0.5rem 0;
  vertical-align: middle;
  border: none;
}

.alert-light {
  background-color: #f8f9fa;
}

.border-success {
  border-color: #28a745 !important;
}

.border-warning {
  border-color: #ffc107 !important;
}

.btn-outline-secondary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 576px) {
  .card-body {
    padding: 1.5rem;
  }

  .input-group-lg .form-control,
  .input-group-lg .btn {
    height: 44px;
    font-size: 0.95rem;
  }
}
</style>
